import React, { Component } from 'react';
import styled from 'styled-components';
import throttle from 'lodash/throttle';
import { localize } from 'react-localize-redux';

import { ConversationFilters } from './ConversationFilters';
import { ConversationCard } from './ConversationCard';
import { LoadingIndicator } from 'components/ui/LoadingIndicator';

const StyledConversationListContainer = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  position: relative;
  box-shadow: var(--box-shadow);
`;

const StyledFiltersContainer = styled.div`
  padding: 1rem;
`;

const StyledListContainer = styled.div`
  padding: 0.5rem;
  overflow-y: scroll;
  height: 100%;
`;

const StyledNoResultsContainer = styled.div`
  padding: 2rem 1rem;
  text-align: center;
`;

const StyledNoResultsH3 = styled.h3`
  font-size: 1.5rem;
  font-family: 'Circular-Bold';
`;

class ConversationList extends Component {
  containerRef = React.createRef();

  state = {
    search: '',
    filter: 'all',
  };

  handleConversationSelect = conversation => {
    this.props.setActiveConversation(conversation);
    if (this.props.handleClose) {
      this.props.handleClose();
    }
  };

  handleUpdateFilter = values => {
    this.props.fetchConversations(values);
    this.setState(values);
  };

  handleScroll = e => {
    const scrollStrengthThreshold = -100;
    const scrollElem = this.containerRef.current;
    const maxScrollDistance = scrollElem.scrollHeight - scrollElem.clientHeight;

    if (e.wheelDelta < scrollStrengthThreshold && scrollElem.scrollTop > maxScrollDistance - 10) {
      this.throttledFetch();
    }
  };

  throttledFetch = throttle(
    () => {
      this.props.fetchConversations({ ...this.state, isForMoreConversations: true });
    },
    2000,
    { trailing: false }
  );

  componentDidMount() {
    this.containerRef.current.addEventListener('wheel', this.handleScroll);
  }

  componentWillUnmount() {
    this.containerRef.current.removeEventListener('wheel', this.handleScroll);
  }

  render() {
    const {
      conversations,
      translate,
      activeConversation,
      userType,
      style,
      loadingConversations,
    } = this.props;

    const isEmptyResults =
      conversations.length === 0 && !(this.state.search === '' && this.state.filter === 'all');

    return (
      <StyledConversationListContainer style={style}>
        <StyledFiltersContainer>
          <ConversationFilters
            updateFilter={this.handleUpdateFilter}
            placeholder={translate('searchConversations').props.children}
          />
        </StyledFiltersContainer>
        <StyledListContainer ref={this.containerRef}>
          {isEmptyResults ? (
            <StyledNoResultsContainer>
              <StyledNoResultsH3>{translate('messaging.noResults')}</StyledNoResultsH3>
              <p>{translate('messaging.noResultsDescription')}</p>
            </StyledNoResultsContainer>
          ) : (
            <div>
              {conversations.map(conversation => (
                <ConversationCard
                  isActive={activeConversation && conversation.id === activeConversation.id}
                  onClick={() => this.handleConversationSelect(conversation)}
                  key={`conversation-card-${conversation.id}`}
                  conversation={conversation}
                  userType={userType}
                />
              ))}
            </div>
          )}
          <LoadingIndicator shouldRender={loadingConversations} isCentered={true} />
        </StyledListContainer>
      </StyledConversationListContainer>
    );
  }
}

export default localize()(ConversationList);
